/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Tumba 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Barari": ["Gaseke", "Gashoro", "Karambi", "Kigarama", "Rukore"],
  "Gahabwa": ["Kabuga", "Kagusa", "Mafene", "Munyinya", "Rushaki"],
  "Misezero": ["Kanaba", "Karambi", "Kavumu", "Marembo", "Misezero", "Rurambo", "Taba"],
  "Nyirabirori": ["Bukinga", "Gatare", "Gatsinde", "Gihanga", "Murambi", "Rugando", "Rusura"],
  "Taba": ["Kamuragi", "Mwili", "Nkinda", "Nyirambuga", "Nyirataba", "Ruvumba"]
};